import React from 'react';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import withAuth from 'src/hoc/withAuth';

const apiProFields = '/api/customer/profield/';
const apiSociete = 'http://www.societe.com/cgi-bin/search?champs=';

const oriState = {
  dataContact: undefined, // needed to build the form
  dataProFields: undefined, // needed to build the form
  hasBillingSite: false, // does the customer has a different facturation site ??
  professionalFieldId: -1,
  socialReason: undefined, // Installation Site
  siret: undefined,
  telFax: undefined,
  telOffice: undefined,
  adress: undefined,
  postalCode: undefined,
  city: undefined,
  socialReasonBilling: undefined, // Billing Site (optionnal)
  siretBilling: undefined,
  telFaxBilling: undefined,
  telOfficeBilling: undefined,
  adressBilling: undefined,
  postalCodeBilling: undefined,
  contactId: undefined,
};

class ModalCustomerPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.addMultipleSite = this.addMultipleSite.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.checkSiteValid = this.checkSiteValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.myContact) {
      // Fetch GET
      let queryURL = apiProFields;
      let graphQL = '{ professionalFields{ id, wording } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            this.setState({
              contactId: this.props.myContact.id,
              dataProFields: data['data']['professionalFields'],
            });
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch pro fields: \n' + error);
          }.bind(this)
        );
    }
  }

  checkSiteValid(isBilling) {
    let postfix = isBilling ? 'Billing' : '';

    const hasValidAddress = isBilling || (this.state['city'] && this.state['city'].trim() !== '');

    return (
      this.state['socialReason' + postfix] &&
      this.state['socialReason' + postfix].trim() !== '' &&
      this.state['siret' + postfix] &&
      this.state['siret' + postfix].trim() !== '' &&
      this.state['adress' + postfix] &&
      this.state['adress' + postfix].trim() !== '' &&
      this.state['postalCode' + postfix] &&
      this.state['postalCode' + postfix].trim() !== '' &&
      hasValidAddress &&
      ((this.state['telOffice' + postfix] && this.state['telOffice' + postfix].trim() !== '') ||
        (this.state['telFax' + postfix] && this.state['telFax' + postfix].trim() !== ''))
    );
  }

  checkFormValid() {
    return (
      this.state.professionalFieldId &&
      this.state.professionalFieldId !== -1 &&
      this.checkSiteValid(false) &&
      (!this.state.hasBillingSite || this.checkSiteValid(true))
    );
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataProFields } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Client</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Infos professionelles</label>
                  <select
                    name='professionalFieldId'
                    value={this.state.professionalFieldId}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option key={-1} value={-1}>
                      Sélectionner catégorie
                    </option>
                    {dataProFields ? (
                      dataProFields.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.wording}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Raison sociale</label>
                  <input
                    name='socialReason'
                    value={this.state.socialReason}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Nom du client'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Siret &nbsp;&nbsp;&nbsp;
                    <a
                      href={apiSociete + (this.state.socialReason ? encodeURIComponent(this.state.socialReason) : '')}
                      target='_blank'
                    >
                      <span className='icon icon-direction'>
                        <u>recherche societe.com</u>
                      </span>
                    </a>
                  </label>
                  <input
                    name='siret'
                    value={this.state.siret}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Num siret'
                  />
                </div>
                <div className='form-group'>
                  <label>Téléphone Bureau</label>
                  <input
                    name='telOffice'
                    value={this.state.telOffice}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Téléphone bureau du client'
                  />
                </div>
                <div className='form-group'>
                  <label>Numéro Fax</label>
                  <input
                    name='telFax'
                    value={this.state.telFax}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Fax du client'
                  />
                </div>
                <div className='form-group'>
                  <label>Adresse</label>
                  <input
                    name='adress'
                    value={this.state.adress}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Adresse du client'
                  />
                </div>
                <div className='form-group'>
                  <label>Code postal</label>
                  <input
                    name='postalCode'
                    value={this.state.postalCode}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Code postal'
                  />
                </div>
                <div className='form-group'>
                  <label>Ville</label>
                  <input
                    name='city'
                    value={this.state.city}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Ville'
                  />
                </div>
                <div className='form-group'>
                  <label>Site de facturation</label>
                  <button
                    onClick={() => this.addMultipleSite()}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className={this.state.hasBillingSite ? 'icon icon-cross' : 'icon icon-plus'}></span>
                  </button>
                </div>
                {this.state.hasBillingSite && (
                  <div>
                    <div className='form-group'>
                      <label>Raison sociale</label>
                      <input
                        name='socialReasonBilling'
                        value={this.state.socialReasonBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Nom du client'
                      />
                    </div>
                    <div className='form-group'>
                      <label>Siret</label>
                      <input
                        name='siretBilling'
                        value={this.state.siretBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Num siret'
                      />
                    </div>
                    <div className='form-group'>
                      <label>Téléphone Bureau</label>
                      <input
                        name='telOfficeBilling'
                        value={this.state.telOfficeBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Téléphone bureau du client'
                      />
                    </div>
                    <div className='form-group'>
                      <label>Numéro Fax</label>
                      <input
                        name='telFaxBilling'
                        value={this.state.telFaxBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Fax du client'
                      />
                    </div>
                    <div className='form-group'>
                      <label>Adresse</label>
                      <input
                        name='adressBilling'
                        value={this.state.adressBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Adresse du client'
                      />
                    </div>
                    <div className='form-group'>
                      <label>Ville</label>
                      <input
                        name='postalCodeBilling'
                        value={this.state.postalCodeBilling}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='CodePostal Ville'
                      />
                    </div>
                  </div>
                )}
                <div className='form-group'>
                  <label>Contact déclencheur</label>
                  <select
                    name='contactId'
                    value={this.state.contactId}
                    onChange={this.handleInputChange}
                    className='form-control'
                    disabled
                  >
                    <option value={this.state.contactId}>{this.props.myContact.name}</option>
                  </select>
                </div>
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  addMultipleSite() {
    if (!this.state.hasBillingSite) {
      this.setState({
        hasBillingSite: true,
      });
    } else {
      this.setState({
        hasBillingSite: false,
        adressBilling: undefined,
        telOfficeBilling: undefined,
      });
    }
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          customer: {
            professionalField: {
              id: this.state.professionalFieldId,
            },
            status: this.state.status,
            installationSite: {
              socialReason: this.state.socialReason,
              siret: this.state.siret,
              telFax: this.state.telFax && this.state.telFax.trim() != '' ? this.state.telFax : 'Non-renseigné',
              telOffice:
                this.state.telOffice && this.state.telOffice.trim() != '' ? this.state.telOffice : 'Non-renseigné',
              adress: this.state.adress,
              postalCode: `${this.state.postalCode} ${this.state.city}`,
            },
            billingSite: {
              isPresent: this.state.hasBillingSite,
            },
            triggerContact: {
              id: this.props.myContact.id,
            },
            otherContacts: {
              isPresent: false,
            },
          },
        };

        if (this.state.hasBillingSite) {
          json.customer.billingSite['socialReason'] = this.state.socialReasonBilling;
          json.customer.billingSite['siret'] = this.state.siretBilling;
          json.customer.billingSite['telFax'] =
            this.state.telFaxBilling && this.state.telFaxBilling.trim() != ''
              ? this.state.telFaxBilling
              : 'Non-renseigné';
          json.customer.billingSite['telOffice'] =
            this.state.telOfficeBilling && this.state.telOfficeBilling.trim() != ''
              ? this.state.telOfficeBilling
              : 'Non-renseigné';
          json.customer.billingSite['adress'] = this.state.adressBilling;
          json.customer.billingSite['postalCode'] = this.state.postalCodeBilling;
        }

        this.props.onPostResult('customer', postEntity(this.props.authFetch, 'customer', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalCustomerPost);
